import { render, staticRenderFns } from "./BolPhotoForm.vue?vue&type=template&id=524f2258&scoped=true"
import script from "./BolPhotoForm.vue?vue&type=script&lang=js"
export * from "./BolPhotoForm.vue?vue&type=script&lang=js"
import style0 from "./BolPhotoForm.vue?vue&type=style&index=0&id=524f2258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524f2258",
  null
  
)

export default component.exports